import React from "react";

export default function Skills() {
  return (
    <section id="skills" className="w-[90%] md:w-[80%] mx-auto pt-8 pb-10">
      <hr className="border-[#28282b]" />
      <div className="flex justify-between items-start mt-16 mb-8 md:mb-14">
        <div>
          <h3 className="text-[#fbfbff] mb-[40px] md:mb-[48px] text-[36px] md:text-[48px] mb-10 font-regular">
            My Skills
          </h3>
          <h4 className="md:mb-[20px] text-[18px] md:text-[20px] md:w-[80%] font-regular text-[#fdfdfd]">
            Here are some of Programming languages, Frameworks, Libraries &
            tools I'm working & expertise at
          </h4>
        </div>
      </div>

      {/*----SKILL CARDS---- */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-y-6 mb-20">
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>UI & UX</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">User Interface & Exerience</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
            {/* <div className="flex gap-1">
              <div className="bg-green-200 rounded-tl rounded-bl w-4 h-1.5 "></div>
              <div className="bg-green-200 w-4 h-1.5"></div>
              <div className="bg-green-200 w-4 h-1.5"></div>
              <div className="bg-green-200 w-4 h-1.5"></div>
              <div className="bg-slate-600 rounded-tr rounded-br w-4 h-1.5"></div>
            </div> */}
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>Figma</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">Design Tool</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
            {/* <div className="flex gap-1">
              <div className="bg-green-200 rounded-tl rounded-bl w-4 h-1.5 "></div>
              <div className="bg-green-200 w-4 h-1.5"></div>
              <div className="bg-green-200 w-4 h-1.5"></div>
              <div className="bg-green-200 w-4 h-1.5"></div>
              <div className="bg-slate-600 rounded-tr rounded-br w-4 h-1.5"></div>
            </div> */}
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>HTML5</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">Markup Language</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
            {/* <div className="flex gap-1">
              <div className="bg-green-200 rounded-tl rounded-bl w-4 h-1.5 "></div>
              <div className="bg-green-200 w-4 h-1.5"></div>
              <div className="bg-green-200 w-4 h-1.5"></div>
              <div className="bg-green-200 w-4 h-1.5"></div>
              <div className="bg-slate-600 rounded-tr rounded-br w-4 h-1.5"></div>
            </div> */}
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>CSS3</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">Style Sheet</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>Tailwind CSS</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">CSS Framework</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>JavaScript (ES6)</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">Programming Language</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>TypeScript</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">JS Superset</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>ReactJS</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">JavaScript Labrary</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>NextJS</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">JavaScript Framework</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>NodeJS</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">JavaScript Runtime</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>ExpressJS</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">NodeJS Framework</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>MongoDB</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">NoSQL Database</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>JWT</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">Encryption Tool</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
          </div>
        </div>
        {/*----skill single card-------- */}
        <div className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE]">
          <h3>Firebase Auth</h3>
          <div className="flex justify-between items-center gap-5">
            <h4 className="text-sm">Authentication Tool</h4>
            <div className="flex gap-1">
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-green-200 rounded-full w-[9px] h-[9px] "></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
              <div className="bg-slate-600 rounded-full w-[9px] h-[9px]"></div>
            </div>
          </div>
        </div>

        {/*-----------------------EXPLORE MORE BUTTON------- */}

        <a
          href=""
          className="border w-full md:w-[320px] border-[#28282b] rounded-lg px-3 py-3 text-[#DEDEDE] text-center flex items-center justify-center bg-slate-500/10 text-[18px]"
        >
          Explore More <span className="inline-block ml-1"> &#8594;</span>
        </a>
      </div>
      {/* <div className="flex justify-between mb-14">
        <div className="border border-[#28282b] rounded-full px-4 py-1 text-[#DEDEDE]">
          HTML5
        </div>
        <div className="border border-[#28282b] rounded-full px-4 py-1 text-[#DEDEDE]">
          CSS3
        </div>
        <div className="border border-[#28282b] rounded-full px-4 py-1 text-[#DEDEDE]">
          TailwindCSS
        </div>
        <div className="border border-[#28282b] rounded-full px-4 py-1 text-[#DEDEDE]">
          JavaScript
        </div>
        <div className="border border-[#28282b] rounded-full px-4 py-1 text-[#DEDEDE]">
          ReactJS
        </div>
        <div className="border border-[#28282b] rounded-full px-4 py-1 text-[#DEDEDE]">
          NextJS
        </div>
        <div className="border border-[#28282b] rounded-full px-4 py-1 text-[#DEDEDE]">
          NodeJS
        </div>
        <div className="border border-[#28282b] rounded-full px-4 py-1 text-[#DEDEDE]">
          ExpressJS
        </div>
        <div className="border border-[#28282b] rounded-full px-4 py-1 text-[#DEDEDE]">
          MongoDB
        </div>
      </div> */}
      {/* <hr className="border-[#28282b]" /> */}
    </section>
  );
}
